import { Grid, InputLabel, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import TimeHourSelector from "./TimeHourSelector";
import TimeMinuteSelector from "./TimeMinuteSelector";

const TimeSelector = ({name, value, label, onChange, ...props}) => {
  const [hourPart, setHourPart] = useState("00");
  const [minutePart, setMinutePart] = useState("00");

  const REGEX = /^(\d{2}):(\d{2})/;

  useEffect(() => {
    if (!value) {
      setHourPart("00");
      setMinutePart("00");
      return;
    }

    if (typeof value === 'string') {
      const parsedValue = value.indexOf("T") > 0 ? value.substring(value.indexOf('T')+1) : value;

      if (parsedValue.length === 0 || !parsedValue.match(REGEX)) {
        setHourPart("00");
        setMinutePart("00");
        return;
      }
      const matches = parsedValue.match(REGEX);

      const hourFrag = matches[1].length === 2 ? matches[1] : `0${matches[1]}`;
      const minuteFrag = matches[2].length === 2 ? matches[2] : `0${matches[2]}`;
      setHourPart(hourFrag);
      setMinutePart(minuteFrag);
    }

    if (typeof value === 'object') {
      return
    }
  }, [value]);

  useEffect(() => {
    if (onChange) {
      onChange(`${hourPart}:${minutePart}`);
    }
  }, [hourPart, minutePart]);

  const handleHourChanged = (event) => {
    const frag = event.target.value >= 10 ? event.target.value : `0${event.target.value}`;
    setHourPart(frag);
  };

  const handleMinuteChanged = (event) => {
    const frag = event.target.value >= 10 ? event.target.value : `0${event.target.value}`;
    setMinutePart(frag);
  };

  return (
    <>
      <InputLabel>{label}</InputLabel>
      <Grid container alignItems="center">
        <Grid item xs={5.5}>
          <TimeHourSelector
            defaultValue={hourPart}
            onChange={handleHourChanged}
            MenuProps="YearPicker"
          />
        </Grid>
        <Grid item xs={1} textAlign="center">
          <Typography variant="body1" sx={{ transform: "translateY(-.25rem)"}}>
            :
          </Typography>
        </Grid>
        <Grid item xs={5.5}>
          <TimeMinuteSelector
            defaultValue={minutePart}
            onChange={handleMinuteChanged}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default TimeSelector;
